export default __webpack_public_path__ + "static/media/about.767a6411.png";